import React from "react";
import { Typography, Select, MenuItem, InputLabel, Grid, } from "@mui/material";
import MappedText from "../../reports/create-report/shared-components/mapText";




export default function FiltersSection({ formValues, handleInputChange, filterSetList, predefinedGeneList }) {
    return (
      <>
        <Typography variant="h5" sx={{ marginBottom: 2, fontWeight: "bold" }}>
          <MappedText text={"Filters"} />
        </Typography>
  
        <Grid container spacing={2} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} sm={6} md={4}>
            <InputLabel>
              <MappedText text={"Filter Set"} />
            </InputLabel>
            <Select
              fullWidth
              name="filter_set"
              value={formValues.filter_set}
              onChange={handleInputChange}
            >
              {filterSetList.map((fs) => (
                <MenuItem key={fs.id} value={fs.id}>
                  {fs.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
  
          <Grid item xs={12} sm={6} md={4}>
            <InputLabel>
              <MappedText text={"Gene List"} />
            </InputLabel>
            <Select
              fullWidth
              name="predefined_list"
              value={formValues.predefined_list}
              onChange={handleInputChange}
            >
              {predefinedGeneList.map((gl) => (
                <MenuItem key={gl.id} value={gl.id}>
                  {gl.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
      </>
    );
  }